module.exports = __webpack_public_path__ + "img/admin-login.8ff995b2.png";